import React, { useEffect, useState } from "react";
import DOMPurify from "dompurify";
import { Button } from "@mui/material";
import axois from "../../configs/axois";
import baseURL from "../../configs/api";
import { useLocation, useNavigate } from "react-router-dom";
import { useTheme } from "../../components/hooks/useTheme";
import colorConfigs from "../../configs/colorConfigs";
import Cookies from "js-cookie";
import useTenant from "../../components/hooks/useTenant";

export const ViewDailyNotes = () => {
    const tenantId = Cookies.get("tenantId-jj-rental-ui") || "";
    const { handleTenantError }: any = useTenant();
    const { themeStyles } = useTheme();
    const navigate = useNavigate();
    const idNumber = useLocation();
    const [note, setNote] = useState<string>("");
    const [location, setLocation] = useState<string>("");
    const [createdBy, setCreatedBy] = useState<string>("");
    const [currentLocations, setCurrentLocations] = useState<any[]>([]);

    useEffect(() => {
        axois
            .get(`${baseURL}location`, {
                headers: {
                    'X-Tenant-ID': tenantId,
                     "Content-Type": "application/json" 
                },
            })
            .then((response) => {
                setCurrentLocations(() =>
                    response.data.map((item: any) => {
                        return { value: item.id, label: item.locationName };
                    })
                );
                handleTenantError(null);
            })
            .catch((error) => {
               handleTenantError(error);
            });

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (currentLocations.length === 0) return;

        axois
            .get(`${baseURL}dailyNote/${idNumber.state}`, {
                headers: {
                    'X-Tenant-ID': tenantId,
                     "Content-Type": "application/json" 
                },
            })
            .then((response) => {
                setNote(DOMPurify.sanitize(response.data.note, {
                    USE_PROFILES: { html: true },
                }));

                const locationObj = currentLocations.find(loc => loc.value === response.data.locationId);
                if (locationObj) {
                    setLocation(locationObj.label);
                }
                setCreatedBy(response.data.createdBy);
                handleTenantError(null);
            })
            .catch((error) => {
                handleTenantError(error);
            });

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentLocations, idNumber.state]);

    return (
        <>
            <div className={`px-[24px] py-[20px] min-h-screen h-full ${themeStyles.main.tailwindSectionBg}`}>
                <div className={`w-full ${themeStyles.main.tailwindMainBg} border ${themeStyles.main.borderColor} rounded-lg p-[10px] pb-[40px] flex flex-col gap-2.51`}>
                    <div className={`w-full ${themeStyles.main.tailwindMainBg} rounded-lg p-[10px] pb-[40px] flex flex-col gap-2.51`}>
                        <div className="w-full mt-2">
                            <div className={`w-full pb-4`}>
                                <div className={`flex justify-between items-center p-2 border-b ${themeStyles.main.borderColor}`}>
                                    <div className="flex items-center gap-1.5">
                                        <h2 className={`text-lg font-semibold ${themeStyles.main.textHeadingColor}`}>View Daily Notes</h2>
                                    </div>
                                </div>

                                <div className="flex">
                                    <div className="mt-2 p-2 w-full">
                                        <div className="w-full px-2">
                                            <div className="grid grid-cols-3 gap-6">
                                                {/* First Column */}
                                                <div className="space-y-4">
                                                    <div className="flex flex-col gap-1.5">
                                                        <span className={`text-xs font-medium ${themeStyles.main.textHeadingColor}`}>Location</span>
                                                        <span className={`text-sm ${themeStyles.main.textSubHeadingColor}`}>{location}</span>
                                                    </div>
                                                </div>

                                                <div className="space-y-4">
                                                    <div className="flex flex-col gap-1.5">
                                                        <span className={`text-xs font-medium ${themeStyles.main.textHeadingColor}`}>Created By</span>
                                                        <span className={`text-sm ${themeStyles.main.textSubHeadingColor}`}>{createdBy}</span>
                                                    </div>

                                                </div>
                                            </div>

                                            <div className={`mt-4 w-full break-all text-sm ${themeStyles.main.textSubHeadingColor}`} dangerouslySetInnerHTML={{ __html: note }} />

                                            <div className="flex mt-4 gap-4">
                                                <Button variant="contained"
                                                    sx={{
                                                        backgroundColor: colorConfigs.btn.cancel.bg,
                                                        border: colorConfigs.btn.cancel.border,
                                                        color: colorConfigs.btn.cancel.color
                                                    }}
                                                    onClick={() => navigate(-1)}
                                                >
                                                    Cancel
                                                </Button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};
